module.exports = __webpack_public_path__ + "static/media/4.59e0c29b.jpg";